import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesCustomFieldsEditRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-custom-fields-edit',
	path: '/secure/admin/EditCustomField(\\w*)!default.jspa',
};
